import $ from 'jquery';

export default {
  saved() {
    return this.success('Your changes were saved.');
  },

  deleted() {
    return this.success('The item was deleted.');
  },

  success(message) {
    return this.notify('success', 'check_circle_outline', message || 'Your changes have been saved.');
  },

  failed(message) {
    return this.notify('danger', 'error_outline', message || 'Something went wrong. Please try again.');
  },

  notify(type, icon, message) {
    return $.notify(
      {
        icon: icon,
        message: message,
      },
      {
        type: type,
        timer: 3e3,
        placement: {
          from: 'top',
          align: 'center',
        },
        z_index: 1075,
      },
    );
  },

  closeAll() {
    $.notifyClose();
  },
};
